module.exports = __webpack_public_path__ + "static/UpdateSocket-27c567b11179fe3bbcec4aea150db5e4.png";